import { useEffect, type FC } from 'react';

import { TradeBenefitsTiles } from '../TradeBenefitsTiles.tsx';
import { TradeBenefitsTestimonial } from '../TradeBenefitsTestimonial/TradeBenefitsTestimonial.tsx';
import { TradeBenefitsFaq } from '../TradeBenefitsFaq/TradeBenefitsFaq.tsx';
import { TradeApplyHandlerProvider } from '../applyHandler/TradeApplyHandlerProvider.tsx';
import { TradeBenefitsNonTradeHero } from './TradeBenefitsNonTradeHero.tsx';
import { TradeBenefitsOverview } from './TradeBenefitsOverview/TradeBenefitsOverview.tsx';
import { TradeBenefitsTierProgression } from './TradeBenefitsTierProgression/TradeBenefitsTierProgression.tsx';
import { TradeBenefitsApplyBanner } from './TradeBenefitsApplyBanner.tsx';

import { trackPageview } from '../../rewards2020/trackingHelpers.ts';

import containerStyles from '../TradeBenefitsContainer.module.css';

const TradeBenefitsNonTrade: FC = () => {
    useEffect(() => {
        trackPageview({ pageSubType: 'program overview', firmStatus: 'unauthenticated' });
    }, []);

    return (
        <TradeApplyHandlerProvider>
            <div className={containerStyles.root}>
                <TradeBenefitsNonTradeHero />
                <TradeBenefitsTiles />
                <TradeBenefitsTestimonial />
                <TradeBenefitsOverview />
                <TradeBenefitsTierProgression />
                <TradeBenefitsApplyBanner />
                <TradeBenefitsFaq />
            </div>
        </TradeApplyHandlerProvider>
    );
};

export { TradeBenefitsNonTrade };
